<main id="main">
    <p-toast key="toastmsg" position="top-right"></p-toast>

    <div *ngIf="showLinkExpireMsg" class="not-found-section">
        <div class="col-md-12 not-found-body">
            <img src="assets/img/logo/not-found.gif" alt="">
            <p>Membership Link Expired or you might have active membership. If you have any query then contact at <a
                    href="mailto:support@tplsport.com" title="support@tplsport.com">support@tplsport.com</a></p>
        </div>
    </div>

    <section *ngIf="!showLinkExpireMsg" class="academy academy-thank-you-section thankyou">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div id="renew-modal">
                        <div class="modal-content" style="border: none; padding: 0px;">
                            <div class="modal-body">
                                <div class="title-list">
                                    <h3>Select Plan</h3>
                                </div>
                                <ul>
                                    <li *ngFor="let membership of membershipTypeList" class="Premium-list"
                                        [ngClass]="(selectedMembershipType == membership.value)? 'active': ''">
                                        <div (click)="onClickPlan(membership)" class="tems-image">

                                            <div class="price-box">
                                                <i *ngIf="membership.selected" class='pi pi-check'></i>
                                                <span class="price-div"> {{membership.amount}}</span>
                                                <span style="text-transform: capitalize;">
                                                    ( {{membership.value}} )
                                                </span>
                                                <span>
                                                    <span *ngIf="membership.value=='premium'">1 Year</span>
                                                    <!-- <span *ngIf="membership.value=='standard'">{{membership.duration}}
                                                        Months</span> -->
                                                    <span *ngIf="membership.value=='standard'">1 Year</span>
                                                </span>
                                            </div>
                                            <span *ngIf="membership.value=='premium'" class="recomanded">
                                                (Recommended)
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                                <div *ngIf="selectedMembershipType=='premium'" class="benifit-primum">
                                    <hr>
                                    <div class="lbl-custom heading-div"><label>Membership Benefits </label><span>
                                            PREMIUM
                                        </span>
                                        <hr>
                                        <div class="forms-list">
                                            <ol>
                                                <li>
                                                    <p>30 Dozen balls worth 40K free on enrollment.</p>
                                                </li>
                                                <li><span>Free 24 TPL Jerseys with
                                                        academy co‑branding.</span></li>
                                                <li> Top listing on the TPL App. </li>
                                                <li> License to conduct unlimited TPL ranking tournaments at the academy.</li>
                                                <li> Digital promotions for the academy during the tournament. </li>
                                                <li> Affiliation and networking with top 100 academies of
                                                    India. </li>
                                                <li> Special invitation for TPL Player auctions for the director of the Academy. </li>
                                                <li> Court bookings during non peak hours . </li>
                                                <li> Individual promotion and bookings for the chief coach. (Find a coach).</li>
                                                <li> Top 3 active academies of India to get cash rewards and special mentions during the live telecast of the League. </li>
                                                <li> Free VIP Passes for TPL League Matches. </li>
                                                <li> Academy to get personalized referral code for TPL app. (All products and services to attract commissions)</li>
                                                <li>Buy 1, Get 1 Free - Box of Balls (Subject to availability).</li>
                                                <li>To be a part of the Race to Gold initiative.</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="selectedMembershipType=='standard'" class="benifit-standard">
                                    <hr>
                                    <div class="lbl-custom heading-div"><label>Membership Benefits </label><span>
                                            STANDARD
                                        </span>
                                        <hr>
                                        <div class="forms-list">
                                            <ol>
                                                <li>
                                                    <p>6 Dozen balls worth 8K free on enrollment.</p>
                                                </li>
                                                <li>
                                                    <p>Free 6 TPL Jerseys with academy co‑branding.</p>
                                                </li>
                                                <li>
                                                    <p>License to conduct unlimited TPL ranking tournaments at the academy.</p>
                                                </li>
                                                <li>
                                                    <p>Digital promotions for the tournaments.</p>
                                                </li>
                                                <li> Tennis Balls at a discounted price.</li>
                                                <li> Affiliation and networking with top 100 academies of India. </li>
                                                <li> Free General passes for TPL League Matches. </li>
                                                <li> Academy to get personalized referral code for TPL app. (All products and services to attract commissions). </li>
                                                <li> To be a part of the Race to Gold initiative.</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="showError">
                                    <span>Please select membership type. </span>
                                </div>
                            </div>
                            <div class="modal-footer justify-content-center">
                                <button type="button" class="btn btn-primary" (click)="onClickPayNow()">Pay Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </section>
</main>